<template lang='pug'>
  div.root-component-container.pattern-background-purple
    v-container.flex-grow-1(fluid)
      v-row.justify-center
        v-col.d-flex.justify-end(cols='10' md='6' xl='4')
          AccountOptionsBar(light)
      v-row.justify-center
        v-col(cols='10' md='6')
          div(:class="{'thin-screen': $vuetify.breakpoint.width<350}")
            p.text-h5 Fast forward&nbsp;
              router-link.text-h5.link-light(:to="characterRoute") character creation
      v-row.justify-center
        v-col(cols='10' md='6')
          router-link(v-for="(data, key) in day6Resource.poseMarketingVideos"
                      :key="key"
                      :to="characterShareLink(data.shareId)")
            video(autoplay loop muted
                  :class="videoClass(data.fullWidth)")
              source(:src="videoSource(data.fileName, 'webm')" type="video/webm")
              source(:src="videoSource(data.fileName, 'mp4')" type="video/mp4")
    StaticContentFooter
</template>

<script>
import appRoute from '@/router/routes'
import AccountOptionsBar from '@/components/account/account-options-bar'
import StaticContentFooter from '@/components/quickytools/static-content-footer'
import day6Resource from '@/resources/day6'
const isProduction = process.env.VUE_APP_ENVIRONMENT === 'production'

export default {
  name: 'quickytools',
  components: { AccountOptionsBar, StaticContentFooter },
  data: () => ({
    characterRoute: appRoute.day6.main,
    day6Resource
  }),
  methods: {
    videoClass (fullWidth) {
      return fullWidth || this.$vuetify.breakpoint.mobile ? 'full-width' : 'half-width'
    },
    characterShareLink (shareId) {
      return isProduction ? appRoute.day6.openCharacterRoute(shareId, 'utm_source=home_page') : appRoute.day6.main
    },
    videoSource (fileName, extension) {
      return `/poseMarketing/${fileName}.${extension}`
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  line-height: 1.6;
}

video {
  height: auto;
  padding: 2% 5%;
}
video.half-width {
  max-width: 45%;
}
video.full-width {
  max-width: 90%;
}
</style>
